/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_TaglineInputs */

const vi_shop_group_tagline = /** @type {(inputs: Shop_Group_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ngắn (1–2 câu, hiện ở thẻ sản phẩm + đầu trang nhóm)`)
};

/**

* @param {Shop_Group_TaglineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_tagline = /** @type {((inputs?: Shop_Group_TaglineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_TaglineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_tagline(inputs)
});